package top.wcpe.allincore.ui.runtime.host

/** JS：单线程事件循环，普通引用格即可。 */
actual class UiAtomicRef<V> actual constructor() {

    actual constructor(initialValue: V?) : this() {
        value = initialValue
    }

    private var value: V? = null

    actual fun get(): V? = value

    actual fun set(newValue: V?) {
        value = newValue
    }
}
